import { ApiConfig } from "../apiConfig/apiConfig";
import { ApiCallGet, ApiCallPost } from "../apiConfig/apiCall";

const bearerHeaders = () => {
  let raw = null;
  try {
    raw = localStorage.getItem("token") || sessionStorage.getItem("token");
  } catch {
    raw = null;
  }
  if (!raw) {
    return { "Content-Type": "application/json" };
  }
  const token = String(raw).startsWith("Bearer ") ? raw : `Bearer ${raw}`;
  return { "Content-Type": "application/json", Authorization: token };
};

const StakingService = {
  getPackages: async (page = 1, limit = 10) => {
    const { baseStaking, stakingPackages } = ApiConfig;
    const url = `${baseStaking}${stakingPackages}?page=${page}&limit=${limit}`;
    return ApiCallGet(url, bearerHeaders());
  },

  getEarningWallet: async () => {
    const { baseWallet } = ApiConfig;
    const url = `${baseWallet}user-wallet?wallet_type=earning`;
    return ApiCallGet(url, bearerHeaders());
  },

  subscribe: async (packageId, investAmount, walletType = "earning") => {
    const { baseStaking } = ApiConfig;
    const url = `${baseStaking}subscribe`;
    const body = { packageId, investAmount: Number(investAmount), walletType };
    return ApiCallPost(url, body, bearerHeaders());
  },

  getMyPositions: async (page = 1, limit = 10) => {
    const { baseStaking } = ApiConfig;
    const url = `${baseStaking}my-positions?page=${page}&limit=${limit}`;
    return ApiCallGet(url, bearerHeaders());
  },

  getPackagesForCoin: async (currency) => {
    const { baseStaking, stakingPackagesForCoin } = ApiConfig;
    const url = `${baseStaking}${stakingPackagesForCoin}?currency=${encodeURIComponent(currency)}`;
    return ApiCallGet(url, bearerHeaders());
  },

  getUserBalance: async (currencyId, walletType = "earning") => {
    const { baseStaking, stakingUserBalance } = ApiConfig;
    const url = `${baseStaking}${stakingUserBalance}?currencyId=${encodeURIComponent(currencyId)}&walletType=${encodeURIComponent(walletType)}`;
    return ApiCallGet(url, bearerHeaders());
  },

  redeem: async (positionId, redeemAmount) => {
    const { baseStaking, stakingRedeem } = ApiConfig;
    const url = `${baseStaking}${stakingRedeem}`;
    const body = { positionId, redeemAmount: Number(redeemAmount) };
    return ApiCallPost(url, body, bearerHeaders());
  },

  topUp: async (positionId, topUpAmount, walletType = "earning") => {
    const { baseStaking, stakingTopUp } = ApiConfig;
    const url = `${baseStaking}${stakingTopUp}`;
    const body = { positionId, topUpAmount: Number(topUpAmount), walletType };
    return ApiCallPost(url, body, bearerHeaders());
  },

  cancel: async (positionId, cancelReason) => {
    const { baseStaking, stakingCancelPosition } = ApiConfig;
    const url = `${baseStaking}${stakingCancelPosition}/${encodeURIComponent(positionId)}/cancel`;
    const body = { positionId: String(positionId) };
    const reason = String(cancelReason || "").trim();
    if (reason) body.cancelReason = reason;
    return ApiCallPost(url, body, bearerHeaders());
  },

  getPayoutHistory: async (positionId, page = 1, limit = 10) => {
    const { baseStaking, stakingPayoutHistory } = ApiConfig;
    const url = `${baseStaking}${stakingPayoutHistory}?positionId=${encodeURIComponent(positionId)}&page=${page}&limit=${limit}`;
    return ApiCallGet(url, bearerHeaders());
  },

  getSoftStakingPackages: async (page = 1, limit = 10) => {
    const { baseSoftStaking, softStakingPackages } = ApiConfig;
    const url = `${baseSoftStaking}${softStakingPackages}?page=${page}&limit=${limit}`;
    return ApiCallGet(url, bearerHeaders());
  },

  getSoftStakingStatus: async () => {
    const { baseSoftStaking } = ApiConfig;
    const url = `${baseSoftStaking}status`;
    return ApiCallGet(url, bearerHeaders());
  },

  // POST /v1/softstaking/subscribe — body { isActive } (enable/disable soft staking for the user).
  setSoftStakingStatus: async (isActive) => {
    const { baseSoftStaking } = ApiConfig;
    const url = `${baseSoftStaking}subscribe`;
    return ApiCallPost(url, { isActive: Boolean(isActive) }, bearerHeaders());
  },
};

export default StakingService;
